/** When your routing table is too long, you can split it into small modules **/

// import Layout from '@/layout'

const contractsRouter = {
  path: '/',
  component: () => import('@/views/base/Index'),
  children: [
    {
      name: '签约列表',
      path: 'contracts',
      component: () => import('@/views/contracts/List'),
    },
    // {
    //   name: '签约详情',
    //   path: 'contracts/:id',
    //   component: () => import('@/views/contracts/Details'),
    // },P
    {
      name: '打印签单',
      path: 'contracts/:id/certificate',
      component: () => import('@/views/contracts/Print'),
    },

    // {
    //   name: '打印结算单',
    //   path: 'contracts/:id/fee',
    //   component: () => import('@/views/contracts/PrintClearing'),
    // },
    {
      name: '客户签单',
      path: 'contracts/customer/:id',
      component: () => import('@/views/contracts/PrintByCustomer'),
    },
  ],
}

export default contractsRouter



